export const GetTemplateColor = (width = 28) => {
    // const backPos = width / 4
    // const backSize = width / 2

    // const patternColor = [
    //     '#707070',
    //     'transparent'
    // ]

    return [
        { key: "white", code: "#ffffff", },
        { key: "black", code: "#000000", },
        { key: "gray", code: "#898989", },
        { key: "red", code: "#ea4444", },
        { key: "yellow", code: "#ffe13b", },
        { key: "orange", code: "#ed7e2c", },
        { key: "beige", code: "#dab289" },
        { key: "green", code: "#40cd50", },
        { key: "blue", code: "#2196f3", },
        { key: "pink", code: "#ff95f1", },
        { key: "purple", code: "#734bc4", },
        // {
        //     key: "pattern",
        //     css: {
        //         backgroundImage: `repeating-linear-gradient(135deg, ${patternColor[0]} 25%, ${patternColor[1]} 25%, ${patternColor[1]} 75%, ${patternColor[0]} 75%, ${patternColor[0]}), repeating-linear-gradient(135deg, ${patternColor[0]} 25%, ${patternColor[1]} 25%, ${patternColor[1]} 75%, ${patternColor[0]} 75%, ${patternColor[0]})`,
        //         backgroundPosition: `0 0, ${backPos}px ${backPos}px`,
        //         backgroundSize: `calc(${backSize}px) calc(${backSize}px)`
        //     }
        // },
        { key: "rainbow", code: "linear-gradient(135deg, red 0%, red 8%, orange 20%, yellow 35%, rgba(0, 255, 0, 0.6) 50%, cyan 65%, rgba(0, 0, 255, 0.8), violet 92%, violet 100%)" },
    ]
}
